import { render, staticRenderFns } from "./PerksAtWorkLandingPage.vue?vue&type=template&id=7aa51752"
import script from "./PerksAtWorkLandingPage.vue?vue&type=script&lang=js"
export * from "./PerksAtWorkLandingPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports